export default __webpack_public_path__ + "static/media/TwoFog.581a3919.svg";